module.exports = "<p>\n  oursegments works!\n</p>\n"